export default __webpack_public_path__ + "bd0b89e9277f8862acdf0d4074c98491.svg";